// extracted by mini-css-extract-plugin
export default {"Card":"SearchBar_Card__XZIdA"};